import { FulfillmentStatus } from 'src/utils/enums';

interface Fulfillment {
  status: FulfillmentStatus;
  shipmentDate?: string | null;
  timeStamp?: string | null;
}

const sortFulfillments = (a: Fulfillment, b: Fulfillment): number => {
  let sortValue = 0;
  const statusA = a.status;
  const dateA = a?.shipmentDate || a?.timeStamp;
  const statusB = b?.status;
  const dateB = b?.shipmentDate || b?.timeStamp;

  // Sort by date
  if (dateA && dateB) {
    const timeA = dateA ? new Date(dateA).getTime() : 0;
    const timeB = dateB ? new Date(dateB).getTime() : 0;
    sortValue = timeB - timeA;
  }

  // If dates are the same, sort by status
  if (sortValue === 0) {
    if (statusA === FulfillmentStatus.DELIVERED) {
      sortValue = -1;
    }
    if (statusB === FulfillmentStatus.DELIVERED) {
      sortValue = 1;
    }
  }

  return sortValue;
};

export default sortFulfillments;
